module.exports = __webpack_public_path__ + "assets/img/seed_trace_value.271bec7f.png";